import React, { useState } from 'react';

const questions = [
    { text: "You regularly make yourself responsible for another person's wellbeing.", emoji: "🧑‍🤝‍🧑" },
    { text: "You're living a lifestyle that isn't conducive to feeling energized.", emoji: "🛋️" },
    { text: "Your life is constantly on the move, leaving little time for leisure or enjoyment.", emoji: "🏃" },
    { text: "You're always engaged in too much multitasking.", emoji: "🤹" },
    { text: "You're considered the \"go to\" individual for friends, colleagues, family.", emoji: "🦸" },
    { text: "You push yourself to do too much too often.", emoji: "😫" },
    { text: "You struggle when to know when to say \"no.\"", emoji: "📋" }
];

const rules = [
    { title: "LIVE WITH LOVE", desc: "You can love your family fearlessly. You can love your friends freely. You can love what you do in your spare time. You can love your pets. If you focus on love, you will feel fulfilled.", emoji: "❤️" },
    { title: "LIVE YOUR PURPOSE", desc: "When you live with purpose, you don't need to live only for the weekend to roll around. You don't need to stare at the clock and wait for escape. You don't need to feel down on Sunday night heading into Monday morning. You don't need to ignore what motivates or fuels you.", emoji: "🎯" },
    { title: "LIVING WITH GRATITUDE", desc: "It can help snap you out of negative energy and make you feel more fulfilled.", emoji: "🙏" },
    { title: "SPEND TIME WITH HAPPY PEOPLE", desc: "The best way to remain happy and fulfilled is to spend time with happy people as much as possible. It's inspiring. It rubs off on you and will go a long way to helping you lead a fulfilling life.", emoji: "😊" },
    { title: "NO MORE COMPARISONS", desc: "Don't compare how happy you are to how happy someone looks on social media... Everyone has their own path to walk. Everyone has their own skills and talents, and everyone is on their individual quest for fulfillment. So, focus on you.", emoji: "🚫" },
    { title: "GIVE BACK", desc: "If you can leave this world having given more than you took, then you will have done well. And in doing so, you will lead a fulfilling life. Invest in yourself, invest in your future, and when it bears fruit, be prepared to pay it forward.", emoji: "🤲" },
    { title: "PRACTICE FORGIVENESS", desc: "You don't need to give someone forgiveness to make it official. You only need to do it within yourself... Everyone makes mistakes, fails, and falls down. So, when you inevitably do, be gentle with yourself.", emoji: "🕊️" },
    { title: "HOLD YOURSELF ACCOUNTABLE", desc: "The words you use matter. Your actions count. Be accountable for your behavior and consider the consequences of those actions and words. The quickest way to run into regret is by not doing so.", emoji: "⚖️" }
];

const questionToRuleMap = [
    rules[0], // Q1 -> Live with Love
    rules[1], // Q2 -> Live Your Purpose
    rules[2], // Q3 -> Living with Gratitude
    rules[4], // Q4 -> No More Comparisons
    rules[5], // Q5 -> Give Back
    rules[6], // Q6 -> Practice Forgiveness
    rules[7]  // Q7 -> Hold Yourself Accountable
];

export const CupCheck = () => {
    const [view, setView] = useState('home');
    const [contact, setContact] = useState('');
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleStart = async () => {
        if (!contact.trim()) {
            setError('Please enter your contact info to continue.');
            return;
        }

        setError('');
        setIsSubmitting(true);

        try {
            await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    access_key: '4a2b131e-c9ff-4f2a-8980-fc8cea007c47',
                    subject: 'New SIP Assessment Lead',
                    contact_info: contact.trim(),
                    from_name: 'HEATH & Wellbeing - Cup Check'
                })
            });
        } catch (err) {
            console.error('Web3Forms error:', err);
        }

        setIsSubmitting(false);
        setView('question');
    };

    const handleAnswer = (answer) => {
        const newAnswers = [...answers, answer];
        setAnswers(newAnswers);

        if (currentQuestion + 1 < questions.length) {
            setCurrentQuestion(currentQuestion + 1);
        } else {
            setView('processing');
            setTimeout(() => setView('results'), 2000);
        }
    };

    const handleReset = () => {
        setView('home');
        setContact('');
        setCurrentQuestion(0);
        setAnswers([]);
        setError('');
    };

    const yesCount = answers.filter(a => a === 'yes').length;
    const progress = ((currentQuestion) / questions.length) * 100;
    const isEmpty = yesCount >= 4;

    return (
        <div className="cup-check-container">
            {view === 'home' && (
                <div className="cup-view cup-home-view">
                    <div className="cup-input-section">
                        <label htmlFor="cup-contact" className="cup-label">
                            Enter your email or phone number to begin:
                        </label>
                        <input
                            type="text"
                            id="cup-contact"
                            className="cup-input"
                            placeholder="Email address or Phone number"
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleStart()}
                        />
                        {error && <p className="cup-error">{error}</p>}
                    </div>

                    <button
                        className="btn-primary cup-btn"
                        onClick={handleStart}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Processing...' : 'Start Assessment'}
                    </button>
                </div>
            )}

            {view === 'question' && (
                        <div className="cup-view cup-question-view">
                            <div className="cup-progress-container">
                                <div className="cup-progress-bar" style={{ width: `${progress}%` }}></div>
                            </div>

                            <div className="cup-emoji">{questions[currentQuestion].emoji}</div>

                            <p className="cup-question-number">
                                Question {currentQuestion + 1} of {questions.length}
                            </p>
                            <h3 className="cup-question-text">{questions[currentQuestion].text}</h3>

                            <div className="cup-btn-group">
                                <button className="cup-choice-btn yes" onClick={() => handleAnswer('yes')}>
                                    YES
                                </button>
                                <button className="cup-choice-btn no" onClick={() => handleAnswer('no')}>
                                    NO
                                </button>
                            </div>
                        </div>
                    )}

                    {view === 'processing' && (
                        <div className="cup-view cup-processing-view">
                            <div className="cup-spinner"></div>
                            <h3>Analyzing responses</h3>
                            <p>Identifying your energy levels...</p>
                        </div>
                    )}

                    {view === 'results' && (
                        <div className="cup-view cup-results-view">
                            <h2>{isEmpty ? "Your cup is running on empty." : "Your cup is reasonably full."}</h2>
                            <div className={`cup-status ${isEmpty ? 'empty' : 'full'}`}>
                                {isEmpty ? 'High Risk of Burnout' : 'Balanced Energy'}
                            </div>
                            <p className="cup-results-summary">
                                {isEmpty
                                    ? "Your responses indicate you are consistently giving more energy to your work and others than you are recovering. Here are actionable rules for leading a fulfilling life based on your answers."
                                    : "You seem to be managing your energy well! Keep maintaining these healthy habits by incorporating these rules into your daily life."}
                            </p>

                            <div className="cup-results-cards">
                                {yesCount === 0 ? (
                                    <>
                                        <div className="cup-result-card">
                                            <h4>{rules[3].emoji} {rules[3].title}</h4>
                                            <p>{rules[3].desc}</p>
                                        </div>
                                        <div className="cup-result-card">
                                            <h4>{rules[2].emoji} {rules[2].title}</h4>
                                            <p>{rules[2].desc}</p>
                                        </div>
                                    </>
                                ) : (
                                    answers.map((answer, idx) =>
                                        answer === 'yes' ? (
                                            <div key={idx} className="cup-result-card">
                                                <h4>
                                                    {questionToRuleMap[idx].emoji} {questionToRuleMap[idx].title}
                                                </h4>
                                                <p>{questionToRuleMap[idx].desc}</p>
                                            </div>
                                        ) : null
                                    ).filter(Boolean).slice(0, 3)
                                )}
                            </div>

                            <button className="btn-primary cup-btn" onClick={handleReset}>
                                Retake Check-in
                            </button>
                        </div>
                    )}
                </div>
    );
};

export default CupCheck;
